import { Controller } from 'react-hook-form'
import { cleanAccentsAndDiacritics } from '../../../../utils/stringUtils'
import PatientFormField from '../PatientFormField'
import { useFormContextPatient, validateUnrequiredStringValue } from '../_utils'

const LastName = () => {
    const { control } = useFormContextPatient()

    return (
        <Controller
            control={control}
            name="lastName"
            rules={{
                validate: validateUnrequiredStringValue,
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="input"
                    label="Nom utilisé"
                    dataCyScope="PatientField"
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    {...field}
                    value={cleanAccentsAndDiacritics(String(field?.value?.toUpperCase() ?? ''))}
                    placeholder="Nom utilisé"
                    onKeyUp={(event) => {
                        const cleanInput = cleanAccentsAndDiacritics(String(field.value?.toUpperCase()))
                        event.currentTarget.value = cleanInput
                    }}
                />
            )}
        />
    )
}

export default LastName
